import DevopsHero from './devopsHero/DevopsHero'
import DevopsCounter from './devopsCounter/DevopsCounter'
import DevopsWhat from './devopsWhat/DevopsWhat'
import DevopsCapability from './devopsCapability/DevopsCapability'
import DevopsConfiguration from './devopsConfiguration/DevopsConfiguration'
import DevopsApproach from './devopsApproach/DevopsApproach'
import DevopsMaintain from './devopsMaintain/DevopsMaintain'
import DevopsTestimonial from './devopsTestimonial/DevopsTestimonial'
import DevopsService from './devopsServices/DevopsServices'
import DevopsChoose from './devopsChoose/DevopsChoose'

export default function Devops() {
  return (
    <div>
        <DevopsHero/>
        <DevopsCounter/>
        <DevopsWhat/>
        <DevopsCapability/>
        <DevopsConfiguration/>
        <DevopsChoose/>
        <DevopsApproach/>
        <DevopsMaintain/>
        <DevopsTestimonial/>
        <DevopsService/>
    </div>
  )
}
